





























































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { studentModule } from '@/store/modules/entities/student.module';
import GLoading from '@/components/GLoading.vue';
import { Student } from '@/models/student/student';
import { PagingData } from '@/models/core/paging-data';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GSchoolClassesTable',
  components: { GLoading },
  computed: {},
  methods: {},
})
export default class GSchoolClassesTable extends Mixins(GPageBase) {
  schoolClassColumns: any[] = [];
  tempSchoolClassName: string = '';
  currentPage: number = 1;
  pageSize: number = 20;

  @Prop({ default: 0 }) gradeIndex: number;
  @Prop({ default: (): GradeSchoolClass => new GradeSchoolClass() }) initGradeSchoolClass: GradeSchoolClass;

  mounted() {
    this.schoolClassColumns = [
      {
        title: this.$t('DELETE_SCHOOL_CLASS').toString(),
        slot: 'action',
        width: 120,
        align: 'center',
      },
      {
        title: this.$t('UPDATE_DATA').toString(),
        slot: 'state',
        width: 150,
        align: 'center',
      },
      {
        title: this.$t('GRADE').toString(),
        slot: 'grade',
        width: 100,
        align: 'center',
      },
      {
        title: this.$t('SCHOOL_CLASS').toString(),
        slot: 'schoolClassName',
        align: 'center',
      },
      {
        title: this.$t('NUMBER_OF_PEOPLE').toString(),
        slot: 'studentCount',
        width: 200,
        align: 'center',
      },
    ];
  }

  get isRoleIgsAdmin(): boolean {
    return this.$store.state.account.isRoleIgsAdmin;
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get students(): PagingData<Student> {
    return studentModule.students;
  }

  get schoolClassesByPage(): SchoolClass[] {
    return this.schoolClasses.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage);
  }

  get schoolClasses(): SchoolClass[] {
    return this.schoolClassesByGrade[this.gradeIndex].schoolClasses;
  }

  get studentCountBySchoolClassID(): Map<number, number> {
    return studentModule.studentCountBySchoolClassID;
  }

  get schoolClassesByGrade(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  get initSchoolClassMap(): Map<number, SchoolClass> {
    return this.initGradeSchoolClass.schoolClasses.reduce((result: Map<number, SchoolClass>, schoolClass: SchoolClass) => {
      result.set(schoolClass.schoolClassID, schoolClass);
      return result;
    }, new Map<number, SchoolClass>());
  }

  get lastSchoolClassName(): string {
    if (this.schoolClassesByPage.length === 0) {
      return '';
    }
    return this.schoolClassesByPage.slice(-1)[0].schoolClassName;
  }

  includeStudents(schoolClassID: number) {
    return this.studentCountBySchoolClassID.has(schoolClassID) && this.studentCountBySchoolClassID.get(schoolClassID) > 0;
  }

  handleDeleteSchoolClass(rowIndex: number, schoolClass: SchoolClass) {
    if (this.initSchoolClassMap.has(schoolClass.schoolClassID)) {
      // 元々登録されていたクラスの削除の場合は、行を消さず、背景色で削除扱いとする
      this.schoolClassesByGrade[this.gradeIndex].schoolClasses[this.schoolClassIndex(rowIndex)].deleted = !this.schoolClassesByGrade[this.gradeIndex].schoolClasses[this.schoolClassIndex(rowIndex)]
        .deleted;
    } else {
      this.schoolClassesByGrade[this.gradeIndex].schoolClasses.splice(this.schoolClassIndex(rowIndex), 1);
      if (this.currentPage > 1 && this.schoolClassesByPage.length === 0) {
        this.currentPage--;
      }
    }
  }

  schoolClassIndex(rowIndex: number) {
    return (this.currentPage - 1) * this.pageSize + rowIndex;
  }

  handlePagerChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  // 変更前の情報を保存
  handleFocus(schoolClass: SchoolClass) {
    this.tempSchoolClassName = this.toHankaku(schoolClass.schoolClassName);
  }

  handleBlur(schoolClassIndex: number, schoolClass: SchoolClass) {
    this.updateSchoolClassName(schoolClassIndex, schoolClass);
  }

  handleEnter(schoolClassIndex: number, schoolClass: SchoolClass) {
    this.updateSchoolClassName(schoolClassIndex, schoolClass);
  }

  handleChange(schoolClassIndex: number, schoolClass: SchoolClass) {
    this.schoolClassesByPage[schoolClassIndex].schoolClassName = this.toHankaku(schoolClass.schoolClassName);
  }

  updateSchoolClassName(schoolClassIndex: number, schoolClass: SchoolClass) {
    // schoolClassは値コピーであることに注意する

    const currentSchoolClassName: string = this.toHankaku(schoolClass.schoolClassName);

    if (currentSchoolClassName === '') {
      // 編集前の文字列に戻す
      schoolClass.schoolClassName = this.tempSchoolClassName;
      this.schoolClassesByPage[schoolClassIndex].schoolClassName = this.tempSchoolClassName;
      return;
    } else if (this.isSameSchoolClassName(schoolClassIndex + this.pageSize * (this.currentPage - 1), currentSchoolClassName)) {
      this.showNotice(GEnum.MessageType.Warn, this.$t('EDIT_FAIL').toString(), this.$t('NOTICE_CANNOT_CHANGE_CLASS_NAME').toString());
      // 編集前の文字列に戻す
      schoolClass.schoolClassName = this.tempSchoolClassName;
      this.schoolClassesByPage[schoolClassIndex].schoolClassName = this.tempSchoolClassName;
      return;
    }

    if (this.initSchoolClassMap.has(schoolClass.schoolClassID)) {
      // 元々存在していたクラスのクラス名変更だった場合は更新内容を変更なしか更新かを判定する

      const initSchoolClass: SchoolClass = this.initSchoolClassMap.get(schoolClass.schoolClassID);
      if (initSchoolClass.schoolClassName !== currentSchoolClassName) {
        // クラス名が最初の元から変更されていた場合
        this.schoolClassesByPage[schoolClassIndex].changed = true;
      } else {
        this.schoolClassesByPage[schoolClassIndex].changed = false;
      }
    }
  }

  isSameSchoolClassName(schoolClassIndex: number, schoolClassName: string): boolean {
    return this.schoolClasses.some((sc: SchoolClass, index: number) => {
      if (index === schoolClassIndex) {
        // 編集対象のクラスは除外する
        return false;
      }
      return sc.schoolClassName === schoolClassName;
    });
  }

  get isLastSchoolClassNameBlank(): boolean {
    return this.lastSchoolClassName === '';
  }

  handleAddSchoolClass() {
    if (this.schoolClasses.length > 0 && this.lastSchoolClassName === '') {
      return;
    }
    if (this.schoolClassesByPage.length === this.pageSize) {
      // ページサイズの上限を超えた場合はページ送り
      this.currentPage++;
    }

    const newSchoolClass: SchoolClass = new SchoolClass().deserialize({
      grade: this.schoolClassesByGrade[this.gradeIndex].grade,
      schoolClassName: '',
    });
    newSchoolClass.created = true;
    this.schoolClassesByGrade[this.gradeIndex].schoolClasses.push(newSchoolClass);
  }

  rowBgColor(rowSchoolClass: SchoolClass) {
    if (rowSchoolClass.deleted) return 'delete-row';
  }
}
